import type { Routing } from "../shared";
import { Form, Link, usePathname, useRouter } from "./AppRouterLibs";
import { createNavigationFunctions } from "./functions";
import { createNavigationFunctions as createNavigationFunctionsClient } from "./functions.react-client";
import { SearchParamLink } from "./SearchParamLink";
import { useGeo } from "./useGeo";

export const defineNavigation = (routing: Routing) => {
  const fns = createNavigationFunctions(routing);
  const clientFns = createNavigationFunctionsClient(routing);
  return {
    usePathname,
    useRouter,
    useGeo,
    Link,
    Form,
    SearchParamLink,
    ...fns,
    ...clientFns,
  };
};
